export type TreeKind = "pine" | "spruce" | "oak" | "maple" | "birch" | "sakura" | "wisteria";

export interface TreeDef {
  kind: TreeKind;
  emoji: string;
  /** Focus sessions needed before this species unlocks. */
  minSessions: number;
}

export const TREE_CATALOG: TreeDef[] = [
  { kind: "pine", emoji: "🌲", minSessions: 0 },
  { kind: "spruce", emoji: "🌳", minSessions: 0 },
  { kind: "oak", emoji: "🌳", minSessions: 3 },
  { kind: "maple", emoji: "🍁", minSessions: 6 },
  { kind: "birch", emoji: "🪵", minSessions: 10 },
  { kind: "sakura", emoji: "🌸", minSessions: 15 },
  { kind: "wisteria", emoji: "🪻", minSessions: 21 }
];

const STORAGE_KEY = "nelurio.tree";

export function readSelectedTree(): TreeKind {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY) as TreeKind | null;
    if (value && TREE_CATALOG.some((tree) => tree.kind === value)) return value;
  } catch { /* ignore */ }
  return "pine";
}

export function storeSelectedTree(kind: TreeKind) {
  try { window.localStorage.setItem(STORAGE_KEY, kind); } catch { /* ignore */ }
}
